<template>
  <transition name="flow-dialog-fade">
    <div v-if="visible" class="process-flow-dialog">
      <!-- 弹窗头部 -->
      <div class="dialog-header">
        <div class="header-title">
          <i class="el-icon-s-operation"></i>
          <span>流程进度</span>
        </div>
        <div class="header-controls">
          <i class="el-icon-close close-btn" @click="handleClose"></i>
        </div>
      </div>

      <!-- 流程图容器 -->
      <div class="dialog-body">
        <FlowChart 
          ref="flowChart"
          :isRunning="isRunning"
          :nodes="flowNodes"
          :edges="flowEdges" />
      </div>
    </div>
  </transition>
</template>

<script>
import FlowChart from './FlowChart.vue'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProcessFlowDialog',
  components: {
    FlowChart
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('processFlow', ['isFlowActive', 'isRunning', 'flowSteps']),
    
    flowNodes () {
      return this.flowSteps
    },
    
    flowEdges () {
      const edges = []
      for (let i = 0; i < this.flowSteps.length - 1; i++) {
        edges.push({
          source: this.flowSteps[i].id,
          target: this.flowSteps[i + 1].id
        })
      }
      return edges
    }
  },
  methods: {
    ...mapActions('processFlow', ['pauseFlow']),
    
    handleClose () {
      this.$emit('update:visible', false)
    }
  },
  watch: {
    visible (val) {
      if (!val && this.isFlowActive) {
        this.pauseFlow()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.flow-dialog-fade-enter-active,
.flow-dialog-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.flow-dialog-fade-enter,
.flow-dialog-fade-leave-to {
  opacity: 0;
  transform: translate(20px, 20px) scale(0.9);
}

.process-flow-dialog {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 250px;
  height: 700px;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(230, 230, 230, 0.8);

  .dialog-header {
    padding: 18px 24px;
    background: #fafafa;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-title {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 15px;
      font-weight: 500;
      color: #333;

      i {
        font-size: 18px;
        color: #667eea;
      }
    }

    .header-controls {
      display: flex;
      align-items: center;
      gap: 12px;

      .close-btn {
        cursor: pointer;
        font-size: 20px;
        color: #999;
        transition: all 0.2s ease;

        &:hover {
          color: #f56c6c;
          transform: rotate(90deg);
        }
      }
    }
  }

  .dialog-body {
    flex: 1;
    padding: 30px 24px;
    overflow: hidden;
    background: #fff;
  }
}
</style>
